<template>
    <div class="container">
        <h2 class="profile-page-title">
            {{ $t('my_courses') }}
            <span class="profile-page-title__count">({{ user.userCourses.length }})</span>
        </h2>

        <div v-if="user.userCourses.length">
            <CourseCard
                    :key="course.course.idcourse"
                    :course="course.course"
                    :coursePayments="course.payments"
                    v-for="course in user.userCourses"
                    @uncheck-recurrent="confirmRemoveRecurrent"
            />
        </div>

        <div
                class="text-center pt-5 pb-8"
                v-else
        >
            <p class="h2">{{ $t('my_courses_empty') }}</p>
            <router-link
                    class="btn btn-default"
                    :to="{ name: 'courses' }"
            >
                {{ $t('select_course') }}
            </router-link>
        </div>

        <modal
                :show="confirmDialog"
                @close="confirmDialog=false"
        >
            <template v-slot:header>
                <h2>{{ $t('do_you_really_want_to_dismiss_reccurent') }}</h2>
            </template>
            <p>{{ $t('dismiss_reccurent_notice') }}</p>
            <template v-slot:footer>
                <base-button type="secondary" @click="confirmDialog = false" :disabled="loading">{{ $t('cancel') }}
                </base-button>
                <base-button type="danger" @click="removeRecurrent" :disabled="loading">{{ $t('refuse') }}</base-button>
            </template>
        </modal>

    </div>
</template>

<script>
    import userApi from '@/data/UserApi';
    import CourseCard from './CourseCard';
    import courseApi from "../../../data/CourseApi";

    export default {
        name: 'Browse',

        data() {
            return {
                user: {
                    // ...properties
                    userCourses: []
                },
                confirmDialog: false,
                removeRecurrentCourse: null,
                loading: false,
            }
        },

        created() {
            this.fetchProfile();
        },

        methods: {
            fetchProfile() {
                userApi.fetchProfile()
                    .then(response => {
                        this.user = response;
                    });
            },

            confirmRemoveRecurrent(course) {
                this.removeRecurrentCourse = course
                this.confirmDialog = true
            },

            removeRecurrent() {
                if (this.removeRecurrentCourse) {
                    this.loading = true
                    this.confirmDialog = false
                    courseApi.removeMyRecurrent(this.removeRecurrentCourse.idcourse)
                        .then(response => {
                            this.fetchProfile()
                        })
                        .catch(error => {
                            let data = error.response.data
                            this.error = this.pretty(data)
                            this.loading = false
                        })
                }
            }
        },

        components: {
            CourseCard,
        }
    }
</script>

<style>
    .profile-page-title__count {
        color: #c0c0c0;
        font-size: 1rem;
    }

    /* cards */
    .course-card {
        border: 1px solid #d7e0e5;
        border-radius: 6px;
        margin-bottom: 30px;
        padding: 20px;
        position: relative;
    }

    .course-card-title {
        display: block;
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
        line-height: 1.4;
    }

    .course-card-title__language {
        color: #c0c0c0;
    }

    .course-card__button {
        border-radius: 18px;
        color: #fff !important;
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
    }

    .course-card__button--red {
        background-color: #f15a21;
    }

    .course-card__description,
    .course-card__description p {
        color: #999 !important;
        line-height: normal;
    }
</style>
